import { Public } from '@mui/icons-material'

import { GeoChart } from '@/components/charts/GeoChart'

import { DimensionReport } from './DimensionReport'

export function GeoPage() {
    return (
        <DimensionReport
            title="Geography"
            emptyIcon={<Public />}
            emptyTitle="No geographic data yet"
            emptyDescription="Countries come from the edge location of each request."
            tabs={[
                {
                    dim: 'country',
                    label: 'Country',
                    chart: rows => (
                        <GeoChart
                            data={rows.map(r => ({ country: r.key, visitors: r.visitors }))}
                        />
                    ),
                },
            ]}
        />
    )
}
